export const notImplemented = () => { throw new Error("Not implemented"); };